module.exports = "static/styles/images/support_link.e22dd0681768b39241dfb9aa7e8de2ed.png";


//////////////////
// WEBPACK FOOTER
// ./lib/help/styles/images/support_link.png
// module id = 604
// module chunks = 0